"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculationSection = void 0;
const react_1 = __importStar(require("react"));
const buttons_1 = require("../../buttons");
const CalculationRow_1 = require("../CalculationRow");
const CalculationSection_styles_1 = require("./CalculationSection.styles");
const CalculationSection = ({ advancedItems, items, basicButtonText, advancedButtonText, title, coolingItems, coolingText, heatingItems, heatingText, }) => {
    const [displayAdvancedResult, setDisplayAdvancedResult] = (0, react_1.useState)(false);
    const basicText = basicButtonText || "Basic results";
    const advancedText = advancedButtonText || "Advanced results";
    const calculationItems = displayAdvancedResult ? advancedItems : items;
    return (react_1.default.createElement(CalculationSection_styles_1.Section, null,
        react_1.default.createElement(CalculationSection_styles_1.Header, null, title),
        react_1.default.createElement(CalculationSection_styles_1.Items, null, calculationItems === null || calculationItems === void 0 ? void 0 :
            calculationItems.map((item, index) => (react_1.default.createElement(CalculationSection_styles_1.RowWrapper, { key: index },
                react_1.default.createElement(CalculationRow_1.CalculationRow, Object.assign({}, item, { odd: index % 2 === 0 }))))),
            displayAdvancedResult && coolingItems && coolingItems.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CalculationSection_styles_1.SubHeaderWrapper, null,
                    react_1.default.createElement(CalculationSection_styles_1.SubHeader, null, coolingText)),
                coolingItems.map((item, index) => (react_1.default.createElement(CalculationSection_styles_1.RowWrapper, { key: `${index}` },
                    react_1.default.createElement(CalculationRow_1.CalculationRow, Object.assign({}, item, { odd: index % 2 === 0 }))))))),
            displayAdvancedResult && heatingItems && heatingItems.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CalculationSection_styles_1.SubHeaderWrapper, null,
                    react_1.default.createElement(CalculationSection_styles_1.SubHeader, null, heatingText)),
                heatingItems.map((item, index) => (react_1.default.createElement(CalculationSection_styles_1.RowWrapper, { key: `${index}` },
                    react_1.default.createElement(CalculationRow_1.CalculationRow, Object.assign({}, item, { odd: index % 2 === 0 })))))))),
        advancedItems && (advancedItems === null || advancedItems === void 0 ? void 0 : advancedItems.length) > 0 && (react_1.default.createElement(CalculationSection_styles_1.LinkWrapper, null,
            react_1.default.createElement(buttons_1.Button, { buttonType: "round", label: displayAdvancedResult ? basicText : advancedText, onClick: () => setDisplayAdvancedResult(!displayAdvancedResult) })))));
};
exports.CalculationSection = CalculationSection;
//# sourceMappingURL=CalculationSection.js.map